<div id="pills-deposit">

    <div class="form-row">
        <form id="" class="admin_form" [formGroup]="formData" (ngSubmit)="onSubmit()">
            <div class="col-md-12">
                <div class="form-group">
                    <label>Available Ammount</label>
                    <input type="text" [value]="data?.user?.available_balance" readonly name="" id="" class="form-control">
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>Deposit Ammount</label>
                    <input type="number" formControlName="deposit_chips" name="" id="" class="form-control" min="0" max="100705997" autocomplete="off">
                    <div>
                        <small>Remaining balance : {{remainBal()}}</small>
                    </div>
                </div>
            </div>
            <div class="col-md-12" *ngIf="data && data?.parent?.id != user?.id">
                <div class="form-group">
                    <label>Master Password *</label>
                    <input type="password" formControlName="parent_password" name="" id="" class="form-control" autocomplete="off">
                </div>
            </div>
            <div class="col-md-12">
                <button class="btn btnSubmit" type="submit" [disabled]="formData.invalid || submitted">deposit</button>
            </div>
        </form>
    </div>

    <app-loader class="full-overlay" *ngIf="!data"></app-loader>

</div>